<template>
    <div
        class="message-delay-slider"
        :class="{ active: active && !previewMode }"
        @click="toggleActive"
        :autofocus="true"
    >
        <div class="delay">
            <span
                class="material-icons"
                @click.prevent="
                    (e) => {
                        e.stopPropagation();
                        active = false;
                        emitActiveState(false);
                    }
                "
            >
                timer
            </span>
            <div class="delay-current" v-if="!active">+{{ mirrorValue }}s {{ $t("chatbotv2.delay") }}</div>
            <div
                class="delay-range"
                v-if="active && !previewMode"
                @click.prevent="
                    (e) => {
                        e.stopPropagation();
                        active = false;
                        emitActiveState(false);
                    }
                "
            >
                +{{ mirrorValue }}s
            </div>
            <vue-slider
                v-model="mirrorValue"
                v-if="active && !previewMode"
                :width="'100%'"
                :min="0"
                :max="15"
                :interval="0.1"
                :tooltipPlacement="'bottom'"
                ref="slider"
                :dotSize="0"
            />
            <div class="delay-range" v-if="active && !previewMode">+15s</div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import _ from "lodash";
import Header from "../../../../../../components/Header.vue";

const log = log2("MessageDelaySlider");
export default {
    name: "MessageDelaySlider",
    components: { Header, VueSlider },
    props: {
        value: {
            type: Number,
            required: true,
        },
        previewMode: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        mirrorValue: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit("input", v);
            },
        },
    },
    data() {
        return {
            active: false,
        };
    },
    methods: {
        toggleActive() {
            this.active = !this.active;
            this.emitActiveState(this.active);
        },
        emitActiveState(state) {
            this.$emit("active-state", state);
        },
    },
    watch: {
        mirrorValue: _.debounce(function (newValue) {
            log("watch.mirrorValue", newValue);
            this.active = false;
            this.emitActiveState(false);
        }, 1000),
    },
};
</script>

<style lang="scss">
.message-delay-slider {
    margin-right: 10px;
    display: flex;
    height: 35px;

    .delay {
        cursor: pointer;
        transition: all 0.3s;
        align-items: center;
        background: #647283;
        border-radius: 13px;
        display: flex;
        height: 25px;
        padding: 0 9px;

        &:hover {
            opacity: 0.8 !important;
        }

        .material-icons {
            color: #fff;
            font-size: 14px;
            font-weight: 700;
            margin-right: 9px;
        }

        .delay-current {
            color: #fff;
            font-size: 15px;
            font-weight: 600;
            line-height: 19px;
        }
    }

    &.active {
        width: 55%;
        display: block;

        .delay {
            &:hover {
                opacity: 1 !important;
            }
        }

        .delay-range {
            color: #fff;
            font-size: 11px;
            font-weight: 600;
        }

        .vue-slider {
            padding: 7px 0px;
            width: 100%;
            height: 6px;
            margin: 0 5px;
            position: relative;
            box-sizing: content-box;
            user-select: none;
            display: block;

            .vue-slider-dot-handle {
                opacity: 0;
            }

            .vue-slider-rail {
                background-color: #b4c0c7;
                border-radius: 3px;
                height: 7px;

                .vue-slider-process {
                    background-color: #fff;
                    border-radius: 3px;
                }
            }

            .vue-slider-dot-tooltip {
                background: black;
                border-radius: 4px;
                box-shadow: 0 0 5px 0 rgb(0 0 0 / 50%);
                color: #091b31;
                cursor: pointer;
                font-weight: 600;
                padding: 0 5px;
                white-space: nowrap;

                &:before {
                    border-color: transparent transparent black;
                    border-style: solid;
                    border-width: 0 6px 7px;
                    content: "";
                    height: 0;
                    left: calc(50% - 6px);
                    position: absolute;
                    top: -7px;
                    width: 0;
                }
            }
        }
    }
}
</style>
